export default __webpack_public_path__ + "static/media/nasa-fitness-tracking-mobile-app.a097d14f.png";